import * as yup from "yup";
import i18n from "utilities/i18n";
import { Recipient } from "generated/graphql.schema";

export const NotificationsSchema = yup.object({
  recipients: yup
    .array()
    .default([])
    .of(
      yup
        .object({
          id: yup.string(),
          confirmed: yup.bool(),
          email: yup.string().email(i18n.t("INVALID_EMAIL"))
        })
        .test("unique", i18n.t("EMAIL_UNIQUE_ERROR"), function() {
          const recipients: Recipient[] = this.parent;
          return (
            recipients.length === new Set(recipients.map(r => r.email)).size
          );
        })
    ),
  newRecipient: yup
    .string()
    .email(i18n.t("INVALID_EMAIL"))
    .default("")
    .test("unique", i18n.t("EMAIL_UNIQUE_ERROR"), function(email) {
      const recipients: Recipient[] = this.parent.recipients;
      const recipientEmails = recipients.map(r => r.email);
      if (recipientEmails.length) {
        const regex = new RegExp(recipientEmails.join("|"), "i"); // this adds case insensitivity to the list of emails
        return !regex.test(email);
      } else {
        return true;
      }
    }),
  enablement: yup
    .bool()
    .default(false)
    .label("Enable Notifications: "),
  notificationTypes: yup
    .array()
    .default([])
    .of(
      yup.object({
        id: yup.string(),
        enabled: yup.bool(),
        actionType: yup.object({ id: yup.string(), type: yup.string() }),
        rate: yup.string(),
        allowedRates: yup.array().of(yup.string())
      })
    )
});

export type NotificationFormProps = yup.InferType<typeof NotificationsSchema>;
